<template>
    <div class="dialog-screen">
        <div class="form-info">
            <div class="form-row fl" style="margin: 0;width: auto;clear: none">
                <div class="form-label">
                    <label class="required">员工信息文件</label>
                </div>
                <div class="form-value">
                    <swb-file-upload class="mt5 fl" fileGroup="comStaff.import" :onBeforeUpload="onBeforeUpload" :onProgress="onProgress" :onDone="onUploadDone" :multipleFile="false"></swb-file-upload>
                </div>
            </div>
            <a class="swb-btn swb-btn-link  fr ml10 mt10" @click="downloadTemplate">下载导入模板</a>
            <div class="form-row fr" style="margin: 0;width: auto;clear: none">
                <div class="form-label">
                    <label>当前导入公司：</label>
                </div>
                <div class="form-value">
                    <span>{{comName || ''}}</span>
                </div>
            </div>
        </div>
        <div class="table-layout">
            <el-table class="thin" :data="pageComImpInfoList" ref="deviceImpInfoTable" border style="width: 100%; font-size: 12px">
                <el-table-column prop="name" label="员工姓名" width="120" class-name="required">
                    <template slot-scope="rows">
                        <input type="text" v-if="!rows.row.validateInfo.name.validateOk" @change="commonChangeEvent" style="background-color: #edd28b; width: 100%" v-model="rows.row.name" :title="rows.row.validateInfo.name.errorMsg"/>
                        <input type="text" v-else style="width:100%" @change="commonChangeEvent" v-model="rows.row.name"/>
                    </template>
                </el-table-column>
                <el-table-column prop="name" label="员工编号" width="120">
                    <template slot-scope="rows">
                        <input type="text" v-if="!rows.row.validateInfo.no.validateOk" @change="commonChangeEvent" style="background-color: #edd28b; width: 100%" v-model="rows.row.no" :title="rows.row.validateInfo.no.errorMsg"/>
                        <input type="text" v-else style="width:100%" @change="commonChangeEvent" v-model="rows.row.no"/>
                    </template>
                </el-table-column>
                <el-table-column prop="no" label="岗位编码" width="120">
                    <template slot-scope="rows">
                        <input type="text" v-if="!rows.row.validateInfo.roleCode.validateOk" @change="commonChangeEvent" style="background-color: #edd28b; width: 100%" v-model="rows.row.roleCode" :title="rows.row.validateInfo.roleCode.errorMsg"/>
                        <input type="text" v-else style="width:100%" @change="commonChangeEvent" v-model="rows.row.roleCode"/>
                    </template>
                </el-table-column>
                <el-table-column prop="phoneNo" label="用户手机" width="100" class-name="required">
                    <template slot-scope="rows">
                        <input type="text" v-if="!rows.row.validateInfo.phoneNo.validateOk" @change="commonChangeEvent" style="background-color: #edd28b; width: 100%" v-model="rows.row.phoneNo" :title="rows.row.validateInfo.phoneNo.errorMsg"/>
                        <input type="text" v-else style="width:100%" @change="commonChangeEvent" v-model="rows.row.phoneNo"/>
                    </template>
                </el-table-column>
                <el-table-column prop="contactTel" label="联系电话" width="100">
                    <template slot-scope="rows">
                        <input type="text" v-if="!rows.row.validateInfo.contactTel.validateOk" @change="commonChangeEvent" style="background-color: #edd28b; width: 100%" v-model="rows.row.contactTel" :title="rows.row.validateInfo.contactTel.errorMsg"/>
                        <input type="text" v-else style="width:100%" @change="commonChangeEvent" v-model="rows.row.contactTel"/>
                    </template>
                </el-table-column>
                <el-table-column prop="contactEmail" label="联系邮箱" width="170">
                    <template slot-scope="rows">
                        <input type="text" v-if="!rows.row.validateInfo.contactEmail.validateOk" @change="commonChangeEvent" style="background-color: #edd28b; width: 100%" v-model="rows.row.contactEmail" :title="rows.row.validateInfo.contactEmail.errorMsg"/>
                        <input type="text" v-else style="width:100%" @change="commonChangeEvent" v-model="rows.row.contactEmail"/>
                    </template>
                </el-table-column>
                <el-table-column prop="idCertNo" label="身份证号" width="150">
                    <template slot-scope="rows">
                        <input type="text" v-if="!rows.row.validateInfo.idCertNo.validateOk" @change="commonChangeEvent" style="background-color: #edd28b; width: 100%" v-model="rows.row.idCertNo" :title="rows.row.validateInfo.idCertNo.errorMsg"/>
                        <input type="text" v-else style="width:100%" @change="commonChangeEvent" v-model="rows.row.idCertNo"/>
                    </template>
                </el-table-column>
                <el-table-column prop="enrollDate" label="入职时间" align="center" width="200">
                    <template slot-scope="rows">
                        <!-- @change="changeDateTime(deviceSubNo)" -->
                        <el-date-picker v-model="rows.row.enrollDate" type="datetime" placeholder="选择日期时间"></el-date-picker>
                    </template>
                </el-table-column>
                <el-table-column prop="memo" label="描述" align="center">
                    <template slot-scope="rows">
                        <el-input type="textarea" class="width-1-5x bottom-line" :rows="3" placeholder="请输入描述" :maxlength="120" v-model="rows.row.memo"></el-input>
                    </template>
                </el-table-column>
                <el-table-column prop="memo" label="操作" align="left" width="60">
                    <template slot-scope="rows">
                        <a class="swb-btn swb-btn-link" @click="removeRow(rows.$index)">移除</a>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <el-pagination background class="mt5" v-if="totalCount > 0" :page-size="pageSize" :page-sizes="pageSizes" :current-page="pageNumber" :total="totalCount" @current-change="handlePageChange" @size-change="handleSizeChange" layout="prev, pager, next, jumper, sizes, total"></el-pagination>
    </div>
</template>

<script>
    import { Utils } from '../../app.base'
    import { Vue, MsgBox, Routes } from '../../app.vues'
    import { openPageRouteUrl, getDefaultPageSizes } from '../../../src/app.conf'

    export default {
        name: 'swb-com-staff-imp-check',
        desc: '公司员工导入检查',
        props: ['comName', 'comId'],
        data: function () {
            return {
                pageNumber: 1,
                totalCount: 0,
                pageSize: null,
                pageSizes: [10, 20, 50, 100],// 特殊页面处理
                //
                pageComImpInfoList: [],
                comStaffImpDto: {},
                //
                max_quantity_per_item: 500,
            }
        },
        watch: {},
        created: function () {
            //
        },
        methods: {
            onBeforeUpload: function (fileItems, uploader) {
                if(fileItems.length === 0) {
                    this.$message.error('请选择要上传的文件');
                    return false;
                }
                this.theLoader = MsgBox.loading("正在解析设备文件");
            },
            //上传进度处理
            onProgress: function (progress) {
                let percentage = Math.floor((progress.loaded / progress.total) * 100);
            },
            //上传完毕处理（根据result.type判断是否有误）
            onUploadDone: function (result) {
                this.theLoader.hide();
                //
                let self = this;
                if(result.type === 'info') {
                    let files = result.data.files;
                    let file = files[0];
                    //
                    let originalFileName = file.extra.originalFileName;
                    let currentComName = this.comName;
                    if(!Utils.isNoB(currentComName) && !Utils.isNoB(originalFileName)) {
                        let fileComName = originalFileName.substring(0, currentComName.length);
                        if(fileComName != currentComName) {     // 上传文件公司名称 - 与导入公司名称不同，提示确认导入
                            //
                            this.$confirm('确定将文件【' + originalFileName + '】导入【' + currentComName + '】 ?', '提示', {
                                confirmButtonText: '确定',
                                cancelButtonText: '取消',
                                type: 'warning'
                            }).then(function () {
                                //
                                self.openComStaffImpCheckDlg(file);
                            }).catch(function () {
                            });
                        } else {
                            this.openComStaffImpCheckDlg(file);     // 相同直接导入
                        }
                    }
                } else {
                    this.$message.warning(result.message);
                }
            },

            openComStaffImpCheckDlg(fileInfo){
                let self = this;
                let theLoading = MsgBox.loading();
                this.comStaffImpDto.originalFileName = fileInfo.extra.originalFileName;
                let comStaffImpInfoList = fileInfo.extra.comStaffImpInfoList;
                comStaffImpInfoList.forEach(function (el) {
                    el.validateInfo = {
                        name: {validateOk: true},
                        no: {validateOk: true},
                        roleCode: {validateOk: true},
                        phoneNo: {validateOk: true},
                        contactTel: {validateOk: true},
                        contactEmail: {validateOk: true},
                        idCertNo: {validateOk: true},
                    };
                });
                this.comStaffImpDto.comStaffImpInfoList = comStaffImpInfoList;
                //
                this.pageSize = this.pageSizes.first();
                self.checkData();
                self.setPageComImpInfoList();
                theLoading.close();
            },

            //
            commonChangeEvent(){
                this.checkData();
            },
            checkData () {
                let rows = this.comStaffImpDto.comStaffImpInfoList.clone();
                for(let i = 0; i < rows.length; i++) {
                    let comStaffImpDto = rows[i];
                    comStaffImpDto.validateInfo = {
                        name: {validateOk: true},
                        phoneNo: {validateOk: true},
                        contactTel: {validateOk: true},
                        contactEmail: {validateOk: true},
                        idCertNo: {validateOk: true},
                        no: {validateOk: true},
                        roleCode: {validateOk: true},
                    };
                    // 检查修正 [员工名称]
                    if(Utils.isNoB(comStaffImpDto.name)) {
                        comStaffImpDto.validateInfo.name = {
                            validateOk: false,
                            errorMsg: "[员工名称]单元不能为空"
                        };
                    }
                    if(!Utils.isNoB(comStaffImpDto.no)) {
                        if(comStaffImpDto.no.length > 15) {
                            comStaffImpDto.validateInfo.no = {
                                validateOk: false,
                                errorMsg: "[员工编号]不可大于15个字符"
                            };
                        }
                    } else {
                        comStaffImpDto.no = null;
                    }
                    // 检查修正 [用户手机]
                    let phoneNo = comStaffImpDto.phoneNo;
                    if(!Utils.isNoB(phoneNo)) {
                        if(!Utils.isMobileNo(phoneNo)) {
                            comStaffImpDto.validateInfo.phoneNo = {
                                validateOk: false,
                                errorMsg: "[用户手机]格式不正确！"
                            };
                        }
                    } else {
                        comStaffImpDto.validateInfo.phoneNo = {
                            validateOk: false,
                            errorMsg: "[用户手机]单元不能为空"
                        };
                    }
                    // 检查联系电话
                    let contactTel = comStaffImpDto.contactTel;
                    if(!Utils.isNoB(contactTel)) {
                        if(!Utils.isPhoneNo(contactTel)) {
                            comStaffImpDto.validateInfo.contactTel = {
                                validateOk: false,
                                errorMsg: "[联系电话]格式不正确！"
                            };
                        }
                    }
                    // [联系邮箱]
                    let contactEmail = comStaffImpDto.contactEmail;
                    if(!Utils.isNoB(contactEmail)) {
                        if(!Utils.isEmail(contactEmail)) {
                            comStaffImpDto.validateInfo.contactEmail = {
                                validateOk: false,
                                errorMsg: "[联系邮箱]格式不正确！"
                            };
                        }
                    } else {
                        // 如果[用户手机]为台湾手机号，联系邮箱不可为空。 -
                        if(/^[0][9][0-9]{8}$/.test(phoneNo)) {
                            console.log("台湾手机号:", phoneNo);
                            //
                            comStaffImpDto.validateInfo.contactEmail = {
                                validateOk: false,
                                errorMsg: "[联系邮箱]不可为空！"
                            };
                        }
                    }
                    // [身份证号]
                    if(!Utils.isNoB(comStaffImpDto.idCertNo)) {
                        if(!isIdentity(comStaffImpDto.idCertNo, false)) {
                            comStaffImpDto.validateInfo.idCertNo = {
                                validateOk: false,
                                errorMsg: "[身份证号]格式不正确！"
                            };
                        }
                    }
                }
                //
                this.comStaffImpDto.comStaffImpInfoList = rows;
            },
            // 计算分页
            setPageComImpInfoList: function () {
                let totalRows = this.comStaffImpDto.comStaffImpInfoList;
                let start = (this.pageNumber - 1) * this.pageSize;
                let end = this.pageNumber * this.pageSize;
                //
                this.pageComImpInfoList = totalRows.slice(start, end);
                this.totalCount = totalRows.length;
            },
            handleSizeChange: function (val) {
                this.pageSize = val;
                this.handlePageChange(1);
            },
            handlePageChange: function (val) {
                this.pageNumber = val;
                this.setPageComImpInfoList();
            },
            // 移除数据
            removeRow: function (index) {
                //
                let comStaffImpInfoList = this.comStaffImpDto.comStaffImpInfoList;
                // 计算元数据里当前数据的下表 index
                let sourceIndex = (this.pageNumber * this.pageSize) - (this.pageSize - index);
                comStaffImpInfoList.splice(sourceIndex, 1);
                //
                this.setPageComImpInfoList();
            },
            //
            checkRequestData: function (comStaffImpInfoList) {
                //
                let staffName = null;
                for(let i = 0; i < comStaffImpInfoList.length; i++) {
                    let comStaffImpInfo = comStaffImpInfoList[i];
                    //
                    let validateInfo = comStaffImpInfo.validateInfo;
                    let checKName = validateInfo.name.validateOk;
                    let checKPhoneNo = validateInfo.phoneNo.validateOk;
                    let checkContactTel = validateInfo.contactTel.validateOk;
                    let checkContactEmail = validateInfo.contactEmail.validateOk;
                    let checkIdCertNo = validateInfo.idCertNo.validateOk;
                    //
                    if(!(checKName && checKPhoneNo && checkContactTel && checkContactEmail && checkIdCertNo)) {
                        staffName = comStaffImpInfo.name;
                        return staffName;
                    }
                }
                return staffName;
            },
            //
            getDlgResult: function () {
                console.log("提交的数据： ", this.comStaffImpDto);
                //
                let result = {};
                result.type = 'info';
                let comStaffImpInfoList = this.comStaffImpDto.comStaffImpInfoList || [];
                if(Utils.isNoB(comStaffImpInfoList) || comStaffImpInfoList.length < 0) {
                    result.type = 'warn';
                    result.message = "导入数据不可为空!";
                    return result;
                } else {
                    // 提交前检查-数据是否合法
                    let staffName = this.checkRequestData(comStaffImpInfoList);
                    if(!Utils.isNoB(staffName)) {
                        result.type = 'warn';
                        result.message = "员工【" + staffName + "】数据未通过检查!";
                        return result;
                    }
                    //
                    result.data = comStaffImpInfoList;
                }
                return result;
            },
            // 下载员工导入模板
            downloadTemplate: function () {
                let self = this;
                // 下载模版
                let url = "/api/servicer/staff/imp/model/template/file/download";
                let params = {
                    comId: self.comId
                };
                url = Utils.makeUrl(url, params);
                Utils.setPageUrl(getAppUrl(url), '_blank');
            },
        }
    }
</script>

<style>
    .el-table .selected-row {
        background: #c9e5f5;
    }
</style>



// WEBPACK FOOTER //
// src/compo/orgStruct/ComStaffImpCheck.vue